<template>
  <div
    class="reviews-prs-plate flex-shrink-0"
    :class="{ 'w-100': isMobile }"
  >
    <CorePRG
      :class="{ 'w-100': isMobile }"
      :url="url"
      :button-attrs="buttonAttrs"
    >
      <div
        class="reviews-prs-plate__content d-flex align-center rounded px-3 py-2"
        :class="{ 'w-100': isMobile }"
      >
        <div
          class="reviews-prs-plate__icon d-flex align-center justify-center flex-shrink-0 rounded-lg bg-lpu-branding-color-primary"
        >
          <span class="ui-icon-piggy-bank ui-icon-fz-big bg-gray-0--text" />
        </div>
        <div
          class="text-body-1 font-weight-medium ml-4 mr-2"
          :class="[
            ff_lpu_branding_page_v5
              ? 'text-lpu-branding-color-text'
              : 'text-lpu-branding-color-primary',
            { 'text-no-wrap': !isMobile },
          ]"
        >
          {{ tStatic('Дарим скидку') }} 300&nbsp;₽ {{ tStatic('за честный отзыв') }}
        </div>
        <span
          class="ui-icon-arrow-right ui-icon-fz-big ml-auto flex-shrink-0"
          :class="ff_lpu_branding_page_v5
            ? 'text-lpu-branding-color-text'
            : 'text-lpu-branding-color-primary'"
        />
      </div>
    </CorePRG>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import CorePRG from 'src/core/CorePRG/CorePRG.vue'
import useIsMobile from 'src/composables/useIsMobile'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

defineProps<{
  url: string
}>()

const { context }: CommonContextStore = useContextStore()
const ff_lpu_branding_page_v5 = computed(() => (
  Boolean(context.request.feature_flags.ff_lpu_branding_page_v5)
))
const isMobile = useIsMobile()

const buttonAttrs = {
  class: 'reviews-prs-plate__control text-left',
  'data-qa': 'lpu_reviews_prs_plate',
}
</script>

<style scoped lang="scss">
.reviews-prs-plate {
  :deep(.reviews-prs-plate__control) {
    border: 0;
    background: transparent;
    cursor: pointer;
    padding: 0;
    width: 100%;
  }

  &__content {
    position: relative;
    isolation: isolate;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      z-index: -1;
      border-radius: inherit;
      background-color: var(--lpu-branding-color-primary);
      opacity: 0.2;
    }
  }

  &__icon {
    width: 40px;
    height: 40px;
  }
}
</style>
